module.exports = __webpack_public_path__ + "static/media/conveyor-belt-alt.080aa016.svg";